import type from './type';
export default {
    [type.MUTATIONS.SET_USERINFO](state, n) {
        state.userInfo = n
    }
}